import React, {ChangeEvent, Component, ReactElement} from 'react'
import {PPTextFieldForResident} from './PPTextFieldForResident'
import EventEmitterExResident from '../../pageBaseComponents/EventEmitterExResident'
import styled from 'styled-components'
import {Nullable} from '../../../../app/TypeHelpers'

interface Props {
    defaultValue: string,
    inputMaxLength: number,
    inputPlaceholder: string
    pullDownItems: Nullable<string[]>,
    handleChangeText: (inputValue: string) => void
    handleClickPullDownItem: (pullDownItems: string) => void
    eventKeys: string,
    eventEmitter: EventEmitterExResident
}

interface State {
    inputValue: string,
    openPullDown: boolean,
}

class PPTextWithPullDownForResident extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            inputValue: this.props.defaultValue,
            openPullDown: false
        }
        this.handleChangeText = this.handleChangeText.bind(this)
        this.handleClickPullDownItem = this.handleClickPullDownItem.bind(this)
        this.handlePullDownOpen = this.handlePullDownOpen.bind(this)
        this.handlePullDownClose = this.handlePullDownClose.bind(this)
        this.handleKeyDown = this.handleKeyDown.bind(this)
    }

    handleChangeText(event: ChangeEvent<HTMLInputElement>): void {
        this.setState({inputValue: event.target.value}, () => {
            this.props.handleChangeText(event.target.value)
        })
    }

    handleKeyDown(event: React.KeyboardEvent, pullDownItem: string): void {
        if (event.key === 'Enter' || event.key === 'Space') {
            this.handleClickPullDownItem(pullDownItem)
        }
    }

    // プルダウンの履歴を押下
    handleClickPullDownItem = (pullDownItem: string) => {
        this.setState({
            inputValue: pullDownItem,
            openPullDown: false
        }, () => {
            this.props.handleClickPullDownItem(pullDownItem)
        })
    }

    // プルダウンを開く
    handlePullDownOpen(): void {
        this.setState({openPullDown: true})
    }

    // プルダウンを閉まる
    handlePullDownClose(): void {
        this.setState({openPullDown: false})
    }

    render(): ReactElement {
        const {inputMaxLength, inputPlaceholder, pullDownItems, eventKeys, eventEmitter} = this.props
        const {inputValue} = this.state

        const handleBlur = (ev: React.FocusEvent<HTMLDivElement>) => {
            if (this.state.openPullDown && !ev.currentTarget.contains(ev.relatedTarget)) {
                this.handlePullDownClose()
            }
        }
        return (
            <Wrapper onBlur={handleBlur}>
                <PPTextFieldForResident
                    inputProps={{
                        maxLength: inputMaxLength,
                        name: eventKeys,
                        value: inputValue,
                        placeholder: inputPlaceholder
                    }}
                    onChange={this.handleChangeText}
                    onFocus={this.handlePullDownOpen}
                    eventKeys={[eventKeys]}
                    eventEmitter={eventEmitter}
                />
                <StyledPullDown $display={this.state.openPullDown}>
                    {pullDownItems?.map((item, index) =>
                        <StyledPullDownItem
                            key={index}
                            tabIndex={0}
                            onClick={() => this.handleClickPullDownItem(item)}
                            onKeyDown={(event) => this.handleKeyDown(event, item)}
                            $inputValue={inputValue}
                            $itemValue={item}
                        >
                            {item}
                        </StyledPullDownItem>
                    )}
                </StyledPullDown>
            </Wrapper>
        )
    }
}

export default PPTextWithPullDownForResident

const Wrapper = styled.div`
    position: relative;
    width: 100%;
`

const StyledPullDown = styled.ul<{ $display?: boolean }>`
    list-style: none;
    width: 100%;
    margin: 0;
    padding: 0;
    background-color: white;
    box-shadow: 0 1px 8px 0 rgba(112, 112, 112, 0.4);
    position: absolute;
    z-index: 10;
    display: ${(props) => (props.$display ? 'block' : 'none')};
`

const StyledPullDownItem = styled.li<{ $inputValue: string, $itemValue: string }>`
    padding: 15px;
    text-align: left;
    display: ${(props) => (
            (props.$itemValue.includes(props.$inputValue) || props.$itemValue === props.$inputValue) ? 'block' : 'none'
    )};
    cursor: default;

    &:hover {
        background-color: rgba(0, 0, 0, 0.04);
    }

    &:focus {
        background-color: rgba(217, 217, 217, 0.5);
    }

    &:active {
        background-color: rgba(0, 112, 176, 0.1);
    }
`
